import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import './guides.css';
import './index.css';
import './scrollfix.css';
import AppContextProvider from './store/AppContext';
import { ThemeProvider } from '@mui/material/styles';
import theme from './styles/theme';

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </ThemeProvider>,
  document.getElementById('root')
);
